// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S2sg2","index":"styles_index__2Kvry"};